import { lazy } from "react";
import { addHandleRoute, createRoute } from "../utils/RouteHelper";

// route
export const paymentRoute = createRoute({
    path: "/payment",
    name: "menu.payment",
    icon: "payments",
    accCode: "pembayaran",
});

export const payDebitRoute = createRoute({
    path: `${paymentRoute.path}/debit`,
    name: "common.debit",
    accCode: "pembayaran_debit",
    parentCode: paymentRoute.accCode,
});

export const payDebitViewRoute = createRoute({
    path: `${payDebitRoute.path}/view`,
    name: "payment_debit.detail",
    accCode: "pembayaran_debit",
    parentCode: paymentRoute.accCode,
});

export const payCreditRoute = createRoute({
    path: `${paymentRoute.path}/credit`,
    name: "common.credit",
    accCode: "pembayaran_kredit",
    parentCode: paymentRoute.accCode,
});

export const payCreditViewRoute = createRoute({
    path: `${payCreditRoute.path}/view`,
    name: "payment_credit.detail",
    accCode: "pembayaran_kredit",
    parentCode: paymentRoute.accCode,
});

export const payCommissionRoute = createRoute({
    path: `${paymentRoute.path}/commission`,
    name: "common.commission",
    accCode: "",
    parentCode: paymentRoute.accCode,
});

// component
const Payment = lazy(() => import("../page/payment/Payment"));

const PayDebit = lazy(() => import("../page/payment/debit/Debit"))
const PayDebitView = lazy(() => import("../page/payment/debit/view/DebitView"))

const PayCredit = lazy(() => import("../page/payment/credit/Credit"))
const PayCreditView = lazy(() => import("../page/payment/credit/view/CreditView"))

const PayCommission = lazy(() => import("../page/payment/commision/Commission"))

export const paymentListRoutes = [payDebitRoute, payCreditRoute, payCommissionRoute];
export const paymentMutationRutes = [
    payDebitViewRoute,
    payCreditViewRoute
]

export const paymentRoutes = {
    element: <Payment />,
    children: addHandleRoute([
        { ...payDebitRoute, element: <PayDebit /> },
        { ...payDebitViewRoute, element: <PayDebitView /> },
        { ...payCreditRoute, element: <PayCredit /> },
        { ...payCreditViewRoute, element: <PayCreditView /> },
        { ...payCommissionRoute, element: <PayCommission /> },
    ]),
}